import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AiIntractionComponent } from './ai-intraction.component';

const routes: Routes = [
  {
    path:"ai-intraction",
    component:AiIntractionComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AiInteractionRoutingModule { }
